import { render, staticRenderFns } from "./LawLedesServiceList.vue?vue&type=template&id=bf7b8a7c&"
import script from "./LawLedesServiceList.vue?vue&type=script&lang=js&"
export * from "./LawLedesServiceList.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesServiceList.vue?vue&type=style&index=0&id=bf7b8a7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports